import { v4 as uuidv4 } from 'uuid';
import {Pin} from "./pin";

export const createPinFromJSON = pinJson => {

    if (!pinJson) return new Pin(uuidv4(), "Untitled");

    return new Pin(pinJson.uuid, pinJson.title, pinJson.type, pinJson.description, pinJson.lonLat)
};
